import { layoutMarkup } from "../layout/layoutMarkup.js";
import { layoutPublicMarkup } from "../layout/layoutPublicMarkup";
import { statementDefaultContent } from './statementSectionDefaultContent';
import { componentsHelper } from "../../helpers/componentsHelper";
//import l10n from "../../../lang/locallang";

const statementSection = async (param, is_public = false) => {
    componentsHelper.updateLocalization(statementDefaultContent);
    //const { statementText } = l10n.editor;

    // Set default values for param properties
    param.class = param.class ? param.class : 'editor-section editor-statement __' + param.layout;
    param.style = param.style ? param.style : '';
    param.layout = param['@layout'] ? param['@layout'] : 'statementA';
    param.section = 'statementSection';
    let lang = document.documentElement.lang;
    param.content = param.content ? param.content.text : statementDefaultContent[lang].statementText.content;
    //console.log(statementDefaultContent)
    // Check if content is provided, otherwise fetch AI placeholder
    // if (param.content && param.content.text) {
    //     param.content = param.content.text;
    // } else {
    //     param.content = await aiContent.requestForAIPlaceholder('statementSection', param.topic, param.lesson_name);
    // }

    let icon_html = '';
    switch (param.layout) {
        case 'statementA':
            param.class = 'editor-section editor-statement __statementA';
            break;
        case 'statementB':
            param.class = 'editor-section editor-statement __statementB';
            break;
        case 'statementC':
            param.class = 'editor-section editor-statement __statementC';
            break;
        case 'statementNote':
            icon_html = '<div class="editor-notification-icon"><i class="icon icon-info"></i></div>';
            param.class = 'editor-section editor-statement __statementNote';
            break;
        default:
            break;
    }

    param.component = `${icon_html}<div class="fr-editor-statement">${param.content}</div>`;

    if (is_public) {
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export { statementSection };
